/**
 * Font asset mappings using require()
 * Expo bundler handles these and creates proper URLs with content hashes
 *
 * NOTE: Only include fonts that actually exist in assets/fonts/
 * Fonts not included here can still be loaded via remote URL (fontUrl in JSON config)
 */

export const NATIVE_FONT_ASSETS: Record<string, any> = {
  // Only include fonts that exist locally
  arial: require("../../assets/fonts/arial/ArialCEMTBlack.ttf"),
  times_new_roman: require("../../assets/fonts/times_new_roman/Times-New-Roman.ttf"),
  lucida_calligraphy: require("../../assets/fonts/lucida_calligraphy/symphony.ttf"),
};

export const getNativeFontAsset = (slug: string): any | null => {
  return NATIVE_FONT_ASSETS[slug] ?? null;
};
